import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteUnitMapping } from "../../../actions/unitActions";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useSnackbar } from "react-simple-snackbar";
import usePermissions from "../../../utils/permissions";

const useStyles = makeStyles((theme) => ({
  table: { minWidth: 500 },
}));

const MappedUnits = ({ mappings, setOpenMap, setEditMapping }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const { loading: permissionsLoading, canUpdatePage, canDeletePage, isAdmin } = usePermissions();

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this mapping?")) {
      dispatch(deleteUnitMapping(id, openSnackbar));
    }
  };

  const handleEdit = (mapping) => {
    setEditMapping(mapping);
    setOpenMap(true);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const tableStyle = { width: 160, fontSize: 14, borderBottom: "none", padding: "8px", textAlign: "center" };
  const headerStyle = { borderBottom: "none", textAlign: "center" };

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell style={headerStyle}>From Unit</TableCell>
            <TableCell style={headerStyle}>To Unit</TableCell>
            <TableCell style={headerStyle}>Conversion Factor</TableCell>
            <TableCell style={headerStyle}>Edit</TableCell>
            <TableCell style={headerStyle}>Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? mappings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : mappings
          ).map((mapping) => (
            <TableRow key={mapping.id}>
              <TableCell style={tableStyle}>{`${mapping.fromUnit.name} (${mapping.fromUnit.abbreviation})`}</TableCell>
              <TableCell style={tableStyle}>{`${mapping.toUnit.name} (${mapping.toUnit.abbreviation})`}</TableCell>
              <TableCell style={tableStyle}>{mapping.conversionFactor}</TableCell>
              <TableCell style={tableStyle}>
                <IconButton
                  disabled={permissionsLoading || (!isAdmin() && !canUpdatePage("Units"))}
                  onClick={() => handleEdit(mapping)}
                  style={{
                    cursor: permissionsLoading || (!isAdmin() && !canUpdatePage("Units")) ? "not-allowed" : "pointer",
                  }}
                >
                  <BorderColorIcon style={{ width: "20px", height: "20px" }} />
                </IconButton>
              </TableCell>
              <TableCell style={tableStyle}>
                <IconButton
                  disabled={permissionsLoading || (!isAdmin() && !canDeletePage("Units"))}
                  onClick={() => handleDelete(mapping.id)}
                  style={{
                    cursor: permissionsLoading || (!isAdmin() && !canDeletePage("Units")) ? "not-allowed" : "pointer",
                  }}
                >
                  <DeleteOutlineRoundedIcon style={{ width: "20px", height: "20px" }} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={5}
              count={mappings.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default MappedUnits;